import { render, staticRenderFns } from "./showAppointments.vue?vue&type=template&id=4bd7be02&scoped=true&"
import script from "./showAppointments.vue?vue&type=script&lang=js&"
export * from "./showAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7be02",
  null
  
)

export default component.exports